import { render, staticRenderFns } from "./SnackbarActions.vue?vue&type=template&id=1b4832ca&scoped=true"
import script from "./SnackbarActions.vue?vue&type=script&lang=js"
export * from "./SnackbarActions.vue?vue&type=script&lang=js"
import style0 from "./SnackbarActions.vue?vue&type=style&index=0&id=1b4832ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4832ca",
  null
  
)

export default component.exports